import DayTradeOnboarding from './Onboarding/onboarding';
import DayTradeTnc from './OnboardingAcceptTnC/terms-conditions';
import DayTradeConfirmation from './OnboardingConfirmation/confirmation';
import DayTradeUnavailable from './OrderUnavailable/unavailable';
import DayTradeLeverage from './PaymentLeverage/leverage';
import DayTradeDebtRatio from './DebtRatio/debt-ratio';

export {
  DayTradeOnboarding,
  DayTradeTnc,
  DayTradeConfirmation,
  DayTradeUnavailable,
  DayTradeLeverage,
  DayTradeDebtRatio,
};
